export function parseKeywordList(input: string | undefined | null): string[] {
  if (!input || typeof input !== 'string') {
    return []
  }

  const parts = input.split(/[,;]/)
  const seen = new Set<string>()
  const result: string[] = []

  for (const part of parts) {
    const trimmed = part.trim()
    if (!trimmed || trimmed.length > 60) {
      continue
    }
    const lower = trimmed.toLowerCase()
    if (seen.has(lower)) {
      continue
    }
    seen.add(lower)
    result.push(trimmed)
    if (result.length === 10) {
      break
    }
  }

  return result
}
